import React from 'react';
import customBadge from '@/components/atoms/CustomBadge/customBadge.module.css';

export type BadgeVariant = 'modelled' | 'revised' | 'override' | 'supplier input' | 'info';

export interface BadgeProps {
  variant?: BadgeVariant;
  label: string;
  icon?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const AtomCustomBadge: React.FC<BadgeProps> = ({
  variant = 'info',
  label,
  icon,
  size = 'md',
  className = '',
}) => {
  const badgeVariant = variant === 'supplier input' ? 'supplierInput' : variant;

  return (
    <div
      className={`
          ${customBadge.badge}
          ${customBadge[badgeVariant]}
          ${customBadge[size]}
          ${className}
        `}
    >
      {icon && <span className={customBadge.icon}>{icon}</span>}
      <span>{label.replace('_', ' ')}</span>
    </div>
  );
};

export default AtomCustomBadge;
